export const fieldToSelect = [
  { disabled: true, field: 'application_id' },
  { disabled: true, field: 'application_email' },
  { disabled: true, field: 'application_createdAt' },
  { disabled: false, field: 'application_createdAtLocal' },
  { disabled: false, field: 'application_ipAddress' },
  { disabled: false, field: 'application_status' },
  { disabled: false, field: 'application_fullName' },
  { disabled: false, field: 'application_barcode' },
  { disabled: false, field: 'application_streetName' },
  { disabled: false, field: 'application_buildingName' },
  { disabled: false, field: 'application_buildingNumber' },
  { disabled: false, field: 'application_apartmentNumber' },
  { disabled: false, field: 'application_postalCode' },
  { disabled: false, field: 'application_city' },
  { disabled: false, field: 'application_country' },
  { disabled: false, field: 'application_region' },
  { disabled: false, field: 'application_province' },
  { disabled: false, field: 'application_household' },
  { disabled: false, field: 'application_phoneNumber' },
  { disabled: false, field: 'application_idNumber' },
  { disabled: false, field: 'application_invoiceNumber' },
  { disabled: false, field: 'application_comments' },
  { disabled: false, field: 'application_createdById' },
  { disabled: false, field: 'application_prizeSelection' },
  { disabled: false, field: 'application_correctAnswersCount' },
  { disabled: false, field: 'application_incorrectAnswersCount' },
  { disabled: false, field: 'application_isFullyCorrect' },
  { disabled: false, field: 'application_dropdown' },
  { disabled: false, field: 'application_points' },
  { disabled: false, field: 'application_verifiedAt' },
  { disabled: false, field: 'application_verifiedAtLocal' },
  { disabled: false, field: 'application_mintsoftOrderId' },
  { disabled: false, field: 'market_name' },
]
